
import keyMirror from 'keymirror';

export default keyMirror({

  // Source code viewer actions
  OPEN_CODE_VIEWER: null,
  UPDATE_CODE_VIEWER: null,
  CLOSE_CODE_VIEWER: null,
  REGISTER_CODE: null,
  UNREGISTER_CODE: null,

});



/** WEBPACK FOOTER **
 ** ./src/guide/actions/action_types.js
 **/